module.exports = __webpack_public_path__ + "assets/img/page-header-bg.8d73bcb1.png";